import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RecommendationQuestionsPage } from './recommendation-questions.page';

const routes: Routes = [
  {
    path: '',
    component: RecommendationQuestionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecommendationQuestionsPageRoutingModule {}
